import { lazy } from "react";
import { Box, makeStyles } from "@material-ui/core";
import { ANALYSIS_KEYS } from "data/models/AnalysisModel";
import { useSelector } from "react-redux";

const useOverlayStyles = makeStyles((theme) => ({
  overlay: {
    position: "fixed",
    width: "inherit",
    height: `calc(100vh - ${theme.spacing(6)}px)`,
    backgroundColor: theme.palette.common.white,
    zIndex: theme.zIndex.drawer + 1,
  },
}));

const DropAPin = lazy(() => import("./drop-a-pin/DropAPin"));

export default function AnalysisFormOverlay() {
  const styles = useOverlayStyles();
  const overlayFormKey = useSelector((state) => state.app.openAnalysisForm);
  const overlayFormOptions = {
    [ANALYSIS_KEYS.DROPAPIN]: DropAPin,
  };

  const OverlayForm = overlayFormOptions[overlayFormKey];
  if (!OverlayForm) {
    return null;
  }
  return (
    <Box className={styles.overlay}>
      <OverlayForm />
    </Box>
  );
}
